import { connect as connectDefault } from '@artsman/ams-loader';

import { CONNECT_META_POSTFIX } from '../constants';

export function connect(reducer, mapApiToProps, options={}) {
  options = {
    metaPostFix: CONNECT_META_POSTFIX,
    ...options
  };
  return connectDefault(reducer, mapApiToProps, options);
}
